<template>
  <div>
    <slot v-if="allowed" />
    <v-alert v-else-if="loading" type="info" text>正在验证财务权限……</v-alert>
    <v-alert v-else type="warning" text>{{ error || '没有查看该财务功能的权限' }}<v-btn v-if="error" text small @click="load">重试</v-btn></v-alert>
  </div>
</template>
<script>
export default {
  props: { permission: { type: String, required: true } },
  data: () => ({ allowed: false, loading: true, error: '' }),
  created() { this.load() },
  methods: {
    async load() {
      this.allowed = false; this.loading = true; this.error = ''
      try {
        const { data } = await this.axios.get('/financial/access')
        if (data.code !== 200) throw new Error(data.message || '获取财务权限失败')
        this.allowed = !!(data.data && data.data[this.permission] === true)
      } catch (error) { this.error = '获取财务权限失败，请重试' }
      finally { this.loading = false }
    }
  }
}
</script>
